import { AVALANCHE_C_CHAIN_ID, CHAIN_CONFIGS, getChainConfig } from '../chains/registry';
import type { TokenConfig } from '../chains/types';

export type { TokenConfig };

const pluginCChain = getChainConfig(AVALANCHE_C_CHAIN_ID);
const ALL_CHAIN_CONFIGS = [
  ...Object.values(CHAIN_CONFIGS),
  ...(pluginCChain && !CHAIN_CONFIGS[pluginCChain.id] ? [pluginCChain] : []),
];

export const CONTRACT_ADDRESSES: Record<number, Record<string, string>> =
  Object.fromEntries(ALL_CHAIN_CONFIGS.map(chain => [chain.id, chain.addresses]));

export const SUPPORTED_TOKENS: TokenConfig[] = Array.from(
  new Map(
    ALL_CHAIN_CONFIGS
      .flatMap(chain => chain.tokens)
      .map(token => [`${token.isPrivate ? 'private' : 'public'}:${token.symbol}`, token])
  ).values()
);

export const MINIMUM_PORTAL_IN_AMOUNTS: Record<string, string> = {
  WBTC: '0.0000145',
  WETH: '0.000497',
  WADA: '4',
  COTI: '82',
  gCOTI: '390',
  USDT: '1',
  'USDC.e': '1',
};

export const ERC20_ABI = [
  'function balanceOf(address owner) view returns (uint256)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 value) returns (bool)',
  'function transfer(address to, uint256 value) returns (bool)',
  'function transferFrom(address from, address to, uint256 value) returns (bool)',
  'function decimals() view returns (uint8)',
  'function symbol() view returns (string)',
  'function name() view returns (string)',
] as const;

// Reuse the portal's existing full bridge ABIs rather than duplicating them.
export {
  TOKEN_ABI,
  BRIDGE_ABI,
  BRIDGE_ERC20_ABI,
  COTI_PRICE_CONSUMER_ABI,
} from '@/contracts/abis';
